import React, { useCallback, useEffect, useRef, useState } from 'react';
import axiosInstance from '../../network/ApiCall';
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import {API_URL, AUTH_TOKEN_NAME, SYSTEM_UNION_CODE} from '../../config';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import {useSelector} from "react-redux";

function CodeListTable() {

  const { t } = useTranslation();
  const authState = useSelector((state) => state.auth);
  const [selectedCode, setSelectedCode] = useState();
  const [codes, setCodes] = useState([]);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadComplete, setUploadComplete] = useState(false);

  const entryData = useRef(null);

  const gridStyle = { minHeight: 550 };

  const unionModeEnabled = Boolean(SYSTEM_UNION_CODE);
  const isUnionAdmin = authState?.user?.roles?.includes('UNION_ADMIN');
  const shouldShowUploadButton = !unionModeEnabled || isUnionAdmin;


  useEffect(() => {
    const loadCodes = () => {
      axiosInstance.get("/codelist")
        .then(response => {
          if (response.data.length) {
            setCodes(response.data)
            setSelectedCode(response.data[0].code)
          }
        })
        .catch(error => {
          console.log("ERROR ", error)
        })
    }
    loadCodes();
  }, []);


  const getCodeListEntries = useCallback(async ({ skip, limit, sortInfo, filterValue }) => {
    // setTableLoading(true)
    const sortData = sortInfo ?? null;
    const result = await axiosInstance.get("/codelistentry/" + selectedCode, {
      params: {
        start: skip,
        length: limit,
        filter: encodeURIComponent(JSON.stringify(filterValue)),
        sort: encodeURIComponent(JSON.stringify(sortData))
      }
    })


    const data = result.data.data;
    const total = result.data.recordsTotal;
    entryData.current = data;
    return { data, count: parseInt(total) }

  }, [selectedCode])

  const filterValue = [
    { name: 'value', operator: 'eq', type: 'string', value: '' },
    { name: 'titleEn', operator: 'contains', type: 'string', value: '' },
    { name: 'descriptionEn', operator: 'contains', type: 'string', value: '' },
  ];

  const currentLanguage = i18next.language;

  const titleRenderer = ({data}) => {
    if (currentLanguage === 'fr' && data.titleFr)
      return data.titleFr;

    if (currentLanguage === 'ru' && data.titleRu)
      return data.titleRu;

    return data.titleEn;
  }

  const descriptionRenderer = ({data}) => {
    if (currentLanguage === 'fr' && data.descriptionFr)
      return data.descriptionFr;

    if (currentLanguage === 'ru' && data.descriptionRu)
      return data.descriptionRu;

    return data.descriptionEn;
  }

  const columns = [
    { name: 'value', header: t("codeLists:lblValue"), sortable: true, renderGroupTitle: () => true },
    { name: 'titleEn', header: t("codeLists:lblTitle"), sortable: true, defaultFlex: 1, render: titleRenderer },
    { name: 'descriptionEn', header: t("codeLists:lblDescription"), sortable: true, defaultFlex: 1, render: descriptionRenderer },

  ]

  const groupColumn = {
    renderGroupValue: ({ value }) => value
  }


  const codeChange = (event) => {
    const newCode = event.target.value;
    setSelectedCode(newCode)
  }

  const closeModal = () => {
    setShowDetailModal(false);
  }

  const closeUploadModal = () => {
    setShowUploadModal(false);
  }

  const onSelectionChange = useCallback(({ selected }) => {
    const selectedEntry = entryData.current.filter((entry) => { return entry.id === selected })[0]

    setSelectedEntry(selectedEntry)
    setShowDetailModal(true)
  }, [])


  const submitNewXSD = (event) => {
    event.preventDefault();
    setUploading(true)
    const dataArray = new FormData();
    dataArray.append("file", uploadedFile);

    const authData = JSON.parse(localStorage.getItem(AUTH_TOKEN_NAME));

    axios.post(API_URL + '/codelist', dataArray, {
      headers: {
        "Content-Type": "multipart/form-data",
        'Authorization': `Bearer ${authData?.access_token}`,
      }
    })
      .then((response) => {
        // successfully uploaded response
        alert('XSD file loaded successfully')
        setUploading(false)
        closeUploadModal();
        setUploadComplete(true)
      })
      .catch((error) => {
        console.log("ERROR RESPONSE  ", error)
        // error response
        setUploading(false)
      });
  };

  if (uploadComplete)
    window.location.href = '/app/codelists'

  return (

    <div className="card h-md-100">
      <div className="card-header bg-light ">
        <div className="row">
          <div className="col">
            <h4>{t('codeLists:hdgHeading')}</h4>
          </div>
          {shouldShowUploadButton && (
          <div className="col-auto text-center pe-card">
            <button id="btnUploadXsd" className="btn btn-sm btn-outline-primary"
              onClick={() => setShowUploadModal(true)}>{t('codeLists:btnUploadXsd')}</button>
          </div>
          )}
        </div>

      </div>
      <div className="card-body p-2">

          <label htmlFor="selCode" className="h5">{t('codeLists:lblSelectCodeList')}</label>
          <select id="selCode" className="form-control mb-4" onChange={codeChange} value={selectedCode}>
            {codes.map((code) =>
              <option key={code.id} value={code.code}>{code.code} {code.titleEn}</option>
            )}
          </select>

          <ReactDataGrid
            idProperty="id"
            style={gridStyle}
            columns={columns}
            defaultFilterValue={filterValue}
            dataSource={getCodeListEntries}
            defaultSortInfo={{ name: 'codeList', dir: 1 }}

            enableSelection={true}
            onSelectionChange={onSelectionChange}
            pagination
            defaultLimit={10}

            stickyGroupRows={true}
            groupColumn={groupColumn}
            defaultGroupBy="codeList"
          />

      </div>

      {showDetailModal && selectedEntry &&
        // <div key="modalKey"  >
        <Modal show={showDetailModal} onHide={closeModal} size="lg" key="mdKey">
          <Modal.Header closeButton>
            {t("codeLists:hdgEntryDetail")}
          </Modal.Header>
          <Modal.Body>
            <dl className="row">
              <dt className="col-3">{t("codeLists:lblValue")}</dt>
              <dd className="col-9">{selectedEntry.value}</dd>

              <dt className="col-3">{t("codeLists:lblTitle")} (en)</dt>
              <dd className="col-9">{selectedEntry.titleEn}</dd>

              <dt className="col-3">{t("codeLists:lblDescription")} (en)</dt>
              <dd className="col-9">{selectedEntry.descriptionEn}</dd>

              <dt className="col-3">{t("codeLists:lblTitle")} (fr)</dt>
              <dd className="col-9">{selectedEntry.titleFr}</dd>

              <dt className="col-3">{t("codeLists:lblDescription")} (fr)</dt>
              <dd className="col-9">{selectedEntry.descriptionFr}</dd>

              <dt className="col-3">{t("codeLists:lblTitle")} (ru)</dt>
              <dd className="col-9">{selectedEntry.titleRu}</dd>

              <dt className="col-3">{t("codeLists:lblDescription")} (ru)</dt>
              <dd className="col-9">{selectedEntry.descriptionRu}</dd>

            </dl>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-outline-secondary" onClick={closeModal}>
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      }

      {showUploadModal &&

        <Modal show={showUploadModal} onHide={closeUploadModal} size="lg" key="mdKey">
          <Modal.Header closeButton>
            XSD File Upload
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={submitNewXSD}>
              <div className="row">
                <label><strong>Select File: </strong></label> <br />
                <br />
                <input name="file" type="file" onChange={(e) => setUploadedFile(e.target.files[0])} accept=".xsd" />
              </div>
              <button type="submit" className="btn btn-success mt-5" disabled={uploading}>{uploading ? 'Please wait' : 'Upload'}</button>
            </form>

          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-outline-secondary" onClick={closeUploadModal}>
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      }
    </div>);
}

export default CodeListTable;